<template>
  <div class="flex flex-column h-screen">
    <transition mode="out-in" name="fade-transform">
      <keep-alive>
        <slot>
          <router-view/>
        </slot>
      </keep-alive>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import {useAppSettings} from '@/composables/useAppSettings.js';
import {watch} from 'vue';
import {useRoute} from 'vue-router';

const {device, secondaryNavViews, toggleSecondaryImportNav} = useAppSettings();
const route = useRoute();

watch(
  () => route.fullPath,
  () => {
    if (device.value === 'mobile' && secondaryNavViews.value.listingImportNav) {
      toggleSecondaryImportNav();
    }
  }
);
</script>